import { MenuIcon } from '@eventbrite/marmalade';
import React from 'react';
import { DropdownContainerProps } from '../../../../types';
import { Dropdown } from '../Dropdown';
import styles from './MobileDropdown.module.scss';

const MobileDropdown = ({
    dropdownItems,
}: Omit<DropdownContainerProps, 'text'>) => {
    return (
        <li className={styles.mobileDropdown} tabIndex={0}>
            <MenuIcon size="small" />
            <Dropdown dropdownItems={dropdownItems} />
        </li>
    );
};

export default MobileDropdown;
